export default __webpack_public_path__ + "static/shopping-centre-1-8ded0d89ee3d04ec75e967d6256b3ce3.jpg";